$('.table--scrollable').wrap('<div class="scrollable"></div>');



// WEBPACK FOOTER //
// ./client/src/site__scf001/components/wysiwyg/tables.js